'use client'

import { Toaster } from '@circlefin/components/lib/Toaster'

export const ToastProvider = () => {
  return <Toaster />
}
